/* eslint-disable */

import jQuery from 'jquery';
import Rails from 'rails-ujs';

import './gdpr';
import { Autocomplete } from './components/Autocomplete';
import { OauthPopup } from './components/OauthPopup';
import { PasswordField } from './components/PasswordField';
import { PhoneCountryCodes } from './components/PhoneCountryCodes';
import { SelectForm } from './components/SelectForm';
import { StepScreen } from './components/StepScreen';

window.$ = window.jQuery = jQuery;

if (!window._rails_loaded) Rails.start();

Autocomplete();
OauthPopup();
PasswordField();
PhoneCountryCodes();
SelectForm();
StepScreen();
